export const Roles = {
    ADMIN: 'admin',
    ONLINE_CUSTOMER: 'customer'
};